/*
 *
 * Coupon constants
 *
 */
export const REDUCER_KEY = 'CouponList';
export const GET_COUPONS = 'app/CouponList/GET_COUPONS';
export const CREATE_COUPON = 'app/CouponList/CREATE_COUPON';
export const UPDATE_COUPON = 'app/CouponList/UPDATE_COUPON';
export const DELETE_COUPON = 'app/CouponList/DELETE_COUPON';
export const RESET_GET_COUPONS = 'app/CouponList/RESET_GET_COUPONS';
